import { render, staticRenderFns } from "./edit_vendor.html?vue&type=template&id=581ed2fd&scoped=true&"
import script from "./edit_vendor.js?vue&type=script&lang=js&"
export * from "./edit_vendor.js?vue&type=script&lang=js&"
import style0 from "./edit_vendor.scss?vue&type=style&index=0&id=581ed2fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ed2fd",
  null
  
)

export default component.exports